import { type ReadContentCommandResult } from '@atlassian/rovo-content-bridge-api-commands';
import { serializeDatabase } from '@databases/ai-first-creation-serializer';
import { collabStateManager } from '@databases/collab-state-manager';
import { logError } from '@databases/logs';
import { appStore } from '@databases/redux/store';
import { selectDatabaseNameByContentIdOptional } from '@databases/utils/redux/databases/selectors';

import { DatabaseStreamState } from '../database-stream-state';

const streamState = DatabaseStreamState.getInstance();

export const readDatabaseContent = (
  contentId: string
): Promise<ReadContentCommandResult> => {
  try {
    const state = appStore.getState();
    const databaseName = selectDatabaseNameByContentIdOptional(state, { contentId });

    const manager = collabStateManager.getCollabManager(contentId);

    if (!manager) {
      throw new Error('Database not found');
    }

    const {
      output: csv,
      warnings,
      rowIdToEntryIdMappings,
    } = serializeDatabase(manager.database);

    if (warnings.hasWarnings()) {
      logError('Warnings during database serialization', new Error(warnings.toString()));
    }

    const title = databaseName || 'Untitled Database';
    const url = window.location.href;

    streamState.populateRowIdToEntryIdMappings(rowIdToEntryIdMappings);

    return {
      contentType: 'database',
      csv,
      title,
      url,
      contentId,
    } as any;
  } catch (possibleError) {
    const error =
      possibleError instanceof Error ? possibleError : new Error(String(possibleError));
    logError('Error reading database content', error);
    throw error;
  }
};
